const AUTH_ATTEMPT_PENDING_KEY = 'tulasi.authAttemptPending';
const AUTH_SESSION_LOST_KEY = 'tulasi.authSessionLost';

export const markAuthAttemptPending = () => {
  try {
    window.sessionStorage.setItem(AUTH_ATTEMPT_PENDING_KEY, 'true');
    window.sessionStorage.removeItem(AUTH_SESSION_LOST_KEY);
  } catch {
    // Some browsers can block sessionStorage in strict privacy modes.
  }
};

export const clearAuthAttemptPending = () => {
  try {
    window.sessionStorage.removeItem(AUTH_ATTEMPT_PENDING_KEY);
  } catch {
    // Ignore unavailable sessionStorage.
  }
};

export const markAuthSessionLostFromPendingAttempt = () => {
  try {
    const hadPendingAuthAttempt = window.sessionStorage.getItem(AUTH_ATTEMPT_PENDING_KEY) === 'true';
    if (window.sessionStorage.getItem(AUTH_ATTEMPT_PENDING_KEY) === 'true') {
      window.sessionStorage.setItem(AUTH_SESSION_LOST_KEY, 'true');
    }
    window.sessionStorage.removeItem(AUTH_ATTEMPT_PENDING_KEY);
    return hadPendingAuthAttempt;
  } catch {
    // Ignore unavailable sessionStorage.
    return false;
  }
};

export const consumeAuthSessionLost = () => {
  try {
    const hasSessionLost = window.sessionStorage.getItem(AUTH_SESSION_LOST_KEY) === 'true';
    window.sessionStorage.removeItem(AUTH_SESSION_LOST_KEY);
    return hasSessionLost;
  } catch {
    return false;
  }
};
